/* eslint-disable */

import React, { useEffect } from "react";
import { registerLicense } from "@syncfusion/ej2-base";

// registerLicense(
//   "ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH9TdkRiXH1bdHFWQmRUWkd2"
// ); //communty license after trail removal
//trailcommunty license
// registerLicense(
// "Ngo9BigBOggjHTQxAR8/V1JEaF1cWWhAYVF/WmFZfVtgdl9FZlZSRWYuP1ZhSXxWdk1gWX9cc3JWQmFVV019XEI="
// ); //trial key

import "./tailwind.output.css";
import * as Sentry from "@sentry/react";
// import ReactDOM from 'react-dom';
import "./index.css";
// import LandingPage from './pages/LandingPage/LandingPage';
// import MainApp from './pages/MainApp/MainApp';
import axios from "axios";
// import RouteHandler from './pages/RouteHandler';
import { Provider } from "react-redux";
// import LandingPage from './pages/LandingPage/LandingPage';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import RouteHandler from "./pages/RouteHandler";
import { NotificationsProvider } from "@mantine/notifications";
import { firebaseInit } from "./utilities/firebase";
import { MantineProvider } from "@mantine/core";
import { BrowserTracing } from "@sentry/tracing";
import { loadConfig } from "./configLoader";
// <-- Replace with your license key
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-dropdowns/styles/material.css";

import "@syncfusion/ej2-layouts/styles/material.css"; // <- add this
import "@syncfusion/ej2-react-documenteditor/styles/material.css"; // <- use this
import constants from "./utilities/constants";

loadConfig().then(() => {
  registerLicense(`${constants.licenseKey}`);
  axios.interceptors.request.use((config) => {
    const axiosConfig = { ...config };
    if (!axiosConfig.noTrailingSlash) {
      axiosConfig.url = config.url.replace(/\/?(\?|#|$)/, "/$1");
    }
    return axiosConfig;
  });
  Sentry.init({
    dsn: "https://7a695925871f4a5b9e54648b971cacec@o1383934.ingest.sentry.io/6701744",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
  firebaseInit();
  const container = document.getElementById("root");
  const root = createRoot(container);
  // const Compo = () => {
  //   useEffect(() => {
  //     console.log('compo mount');
  //   }, []);
  //   return null;
  // };
  root.render(
    // eslint-disable-next-line react/jsx-filename-extension
    <React.Fragment>
      <Provider store={store}>
        <MantineProvider
          // theme={{
          //   // Override any other properties from default theme
          //   fontFamily: "Lato",
          // }}
          //           theme={{
          //     fontFamily: "Lato",

          //     components: {
          //       Button: {
          //         defaultProps: {
          //           radius: "md",
          //         },

          //         styles: (theme) => ({
          //           root: {
          //             borderRadius: "0.5rem",
          //             fontWeight: 500,
          //             transition: "all 0.2s ease",
          //           },

          //           // Filled (contained)
          //           filled: {
          //             backgroundColor: "#46BDE1",
          //             color: "#F5F5F5",

          //             "&:hover": {
          //               backgroundColor: "#2fa4c7",
          //               transform: "translateY(-2px)",
          //               boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
          //             },
          //           },

          //           // Outline
          //           outline: {
          //             border: "1px solid #46BDE1",
          //             color: "#46BDE1",

          //             "&:hover": {
          //               backgroundColor: "#46BDE1",
          //               color: "#fff",
          //               transform: "translateY(-2px)",
          //             },
          //           },
          //         }),
          //       },
          //     },
          //   }}
          theme={{
            fontFamily: "Lato",

            // ✅ Set default primary color
            primaryColor: "primary",

            // ✅ Define semantic color system
            colors: {
              primary: [
                "#e6f4f8",
                "#cce9f1",
                "#99d3e3",
                "#66bdd5",
                "#33a7c7",
                "#2089ae", // main
                "#1b6f8d",
                "#155a73",
                "#104552",
                "#0a2f39",
              ],

              secondary: [
                "#f1f3f5",
                "#e9ecef",
                "#dee2e6",
                "#ced4da",
                "#adb5bd",
                "#868e96",
                "#495057",
                "#343a40",
                "#212529",
                "#121416",
              ],

              danger: [
                "#ffe3e3",
                "#ffc9c9",
                "#ffa8a8",
                "#ff8787",
                "#ff6b6b",
                "#fa5252", // main red
                "#e03131",
                "#c92a2a",
                "#a51111",
                "#7a0b0b",
              ],

              success: [
                "#e6f9f0",
                "#c3f0db",
                "#9de7c5",
                "#75deaf",
                "#52d599",
                "#46BDE1", // 👈 your export color
                "#2fa4c7",
                "#1f8aa8",
                "#166f86",
                "#0d5565",
              ],
            },

            components: {
              Button: {
                defaultProps: {
                  radius: "md",
                  variant: "filled",
                },

                styles: (theme, { color }) => ({
                  root: {
                    borderRadius: "0.5rem",
                    fontWeight: 500,
                    transition: "all 0.2s ease",

                    "&:active": {
                      transform: "scale(0.97)",
                    },
                  },

                  // ✅ Filled (Primary / Danger / Secondary auto)
                  filled: {
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
                    },
                  },

                  // ✅ Outline
                  // outline: {
                  //   border: `1px solid ${theme.colors[color || "primary"][6]}`,
                  //   color: theme.colors[color || "primary"][6],
                  //   backgroundColor: "transparent",

                  //   "&:hover": {
                  //     backgroundColor: theme.colors[color || "primary"][0],
                  //     transform: "translateY(-2px)",
                  //   },
                  // },
                  outline: (theme, { color }) => {
                    // Check if the color exists in the theme, otherwise fallback to 'primary'
                    const colorKey = color in theme.colors ? color : "primary";
                    const mainColor = theme.colors[colorKey][6];
                    const lightColor = theme.colors[colorKey][0];

                    return {
                      border: `1px solid ${mainColor}`,
                      color: mainColor,
                      backgroundColor: "transparent",

                      "&:hover": {
                        backgroundColor: lightColor,
                        transform: "translateY(-2px)",
                      },
                    };
                  },
                }),
              },
            },
          }}
        >
          <NotificationsProvider autoClose={5000}>
            <BrowserRouter>
              <RouteHandler />
            </BrowserRouter>
          </NotificationsProvider>
        </MantineProvider>
      </Provider>
    </React.Fragment>,
  );
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
